import type { Sequence } from "#public"

/**
 * Creates a new object with specified keys removed.
 * Returns a shallow copy without the specified keys.
 *
 * @param obj - Source object
 * @param keys - Array of keys to remove
 * @returns New object without the specified keys
 *
 * @example
 * ```ts
 * import { KeyDrop } from "@pdfking/tfunc"
 *
 * const user = { name: "John", age: 30, password: "secret" }
 * KeyDrop(user, ["password"]) // { name: "John", age: 30 }
 * KeyDrop(user, ["age", "password"]) // { name: "John" }
 * ```
 */
export const KeyDrop = <T extends object, K extends keyof T>(
  obj: T,
  keys: K[] | Sequence<K>
): Omit<T, K> => {
  const result = { ...obj }
  for (const key of keys) {
    delete result[key]
  }
  return result
}
